import http from "../../http-common";
/**
 * Author : LeonardoSarrus
 * 18/11/2025
*/

const purgeClient = (data) => {
    return http.post("/Client/PurgeClient", data);
};

export default {
    purgeClient
};